class Product extends HTMLElement {
  constructor() {
    super();

    this.productForm();
    this.productTabs();
    this.productImages();
    this.productImagesZoom();
    this.productSizeGuide();
  }

  productForm() {
    const variants = (productId, sectionId) => {
      const data = JSON.parse(document.getElementById(`ProductJson${productId}`).innerHTML);

      const selectCallback = (variant) => {
        const that = this.querySelector(`.js-product[data-product-id='${productId}']`);

        if (variant) {
          const priceOldElement = that.querySelector(".js-price-old");
          const priceNewElement = that.querySelector(".js-price-new");
          const priceDefaultElement = that.querySelector(".js-price-default");

          if (variant.compare_at_price > variant.price) {
            if (priceOldElement) {
              priceOldElement.classList.remove("d-none");
              priceOldElement.innerHTML = Shopify.formatMoney(variant.compare_at_price);
            }
            if (priceNewElement) {
              priceNewElement.classList.remove("d-none");
              priceNewElement.innerHTML = Shopify.formatMoney(variant.price);
            }
            if (priceDefaultElement) {
              priceDefaultElement.classList.add("d-none");
            }
          } else {
            if (priceOldElement) priceOldElement.classList.add("d-none");
            if (priceNewElement) priceNewElement.classList.add("d-none");
            if (priceDefaultElement) {
              priceDefaultElement.classList.remove("d-none");
              priceDefaultElement.innerHTML = Shopify.formatMoney(variant.price);
            }
          }

          const soldOutWrappers = that.querySelectorAll('.js-wrap-sold-out');
          const addToCartWrappers = that.querySelectorAll('.js-wrap-add-to-cart');

          if (!variant.available) {
            soldOutWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));
            addToCartWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
          } else {
            soldOutWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
            addToCartWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));
          }

          that.querySelectorAll('.js-wrap-add-to-cart .js-add-to-cart').forEach(button => {
            const originalText = button.getAttribute('data-original-text') || '';

            const formattedPrice = Shopify.formatMoney(variant.price);
            button.textContent = `${originalText} - ${formattedPrice}`;
          });

          document.querySelectorAll('.js-toggle-option').forEach(button => {
            const parent = button.parentElement;
            parent.classList.remove('active');
          });

          const currentVariantId = variant.id;

          document.querySelectorAll('.js-variant-message').forEach(el => {
            el.classList.add('d-none');
          });

          const activeMessage = document.querySelector(`.js-variant-message[data-variant-id="${currentVariantId}"]`);
          if (activeMessage) {
            activeMessage.classList.remove('d-none');
          }
        }
      };

      if (document.getElementById(`product-select-${productId}`)) {
        new Shopify.OptionSelectors(`product-select-${productId}`, {
          product: data,
          onVariantSelected: selectCallback,
          enableHistoryState: true
        });
      }
    };

    document.querySelectorAll(".js-product:not(.active)").forEach((element) => {
      const productId = element.getAttribute("data-product-id");
      const json = document.getElementById(`ProductJson${productId}`);

      if (json) {
        variants(productId);

        element.querySelectorAll('.js-product-size').forEach(sizeElement => {
          sizeElement.addEventListener('click', function (event) {
            event.preventDefault();

            const value = this.getAttribute('data-value');
            const option = this.closest('ul').getAttribute('data-option');

            const productVariants = document.querySelector(`.js-product[data-product-id='${productId}'] select[data-option='${option}']`);
            if (productVariants) {
              productVariants.value = value;
              productVariants.dispatchEvent(new Event('change'));

              const optionValues = document.querySelectorAll(`.js-product[data-product-id='${productId}'] .js-product-size[data-option="${option}"]`);
              if (optionValues.length) {
                optionValues.forEach(optionValue => {
                  optionValue.classList.remove('active');
                });

                this.classList.add('active');
              }
            }

            const currentSizeEl = this.closest('.js-product-option').querySelector('.js-current-size-value');
            if (currentSizeEl) {
              currentSizeEl.textContent = value;
            }
          });
        });
      }

      element.classList.add("active");
    });

    const toggleClass = 'active';

    document.querySelectorAll('.js-toggle-option').forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const parent = this.parentElement;
        parent.classList.toggle(toggleClass);
      });
    });

    document.addEventListener('click', function (e) {
      document.querySelectorAll('.js-toggle-option').forEach(button => {
        const parent = button.parentElement;
        if (!parent.contains(e.target)) {
          parent.classList.remove(toggleClass);
        }
      });
    });
  }

  productTabs() {
    document.querySelectorAll('.js-product-tab').forEach(tab => {
      const height = tab.scrollHeight;
      tab.setAttribute('data-height', height);
      tab.style.height = `${height}px`;
    });

    document.querySelectorAll('.js-toggle-product-tab').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const tab = button.closest('.js-product-tab');
        const savedHeight = tab.getAttribute('data-height');

        if (tab.classList.contains('active')) {
          tab.classList.remove('active');
          tab.classList.add('deactivate');
          tab.style.height = `${savedHeight}px`;

          setTimeout(() => {
            tab.classList.remove('deactivate', 'display');
          }, 300);
        } else {
          tab.classList.add('display');

          setTimeout(() => {
            const height = tab.scrollHeight;
            tab.style.height = `${height}px`; 
            tab.classList.add('active');
          }, 10);
        }
      });
    });
  }

  productImages() {
    document.querySelectorAll('.js-product-images-carousel').forEach((carousel, index) => {
      if (carousel.dataset.splideInitialized === 'true') return;

      const className = `js-product-images-carousel-${index}`;
      carousel.classList.add(className);
      carousel.dataset.splideInitialized = 'true';

      const splide = new Splide(`.${className}`, {
        perPage: 3,
        rewind: false,
        arrows: false,
        pagination: false,
        gap: '6px',
        focus: 'center',
        type: 'loop',
        drag: 'free',
        autoScroll: {
          speed: 1,
          pauseOnHover: false
        },
        breakpoints: {
          1298: {
            perPage: 2,
          },
          991: {
            perPage: 2,
            autoScroll: false
          }, 
          780: {
            perPage: 2,
          },
          500: {
            perPage: 1,
          },
        },
      });

      splide.mount(window.splide?.Extensions || {});
      this.slideCounterFromAria('.js-product-images-counter');
    });
  }

  productImagesZoom() {
    document.querySelectorAll('.js-open-product-zoom').forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        const index = this.dataset.index;
        const zoomElement = document.querySelector('.js-product-image-zoom');

        if (!zoomElement) return;

        zoomElement.classList.add('display');

        if (window.lenis) {
          window.lenis.start();
        } else {
          document.body.style.overflow = 'visible';
        }

        setTimeout(() => {
          zoomElement.classList.add('active');
          zoomElement.dataset.index = index;

          const target = zoomElement.querySelector(`[data-index="${index}"]`);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
          }
        }, 50);
      });
    });

    document.querySelectorAll('.js-product-image-zoom').forEach(zoomElement => {
      zoomElement.addEventListener('click', function (event) {
        event.preventDefault();

        zoomElement.classList.add('closing');

        if (window.lenis) {
          window.lenis.start();
        } else {
          document.body.style.overflow = 'visible';
        }

        setTimeout(() => {
          zoomElement.classList.remove('active', 'display', 'closing');
          delete zoomElement.dataset.index;
        }, 300);
      });
    });
  }

  slideCounterFromAria(counterSelector) {
    const currentEl = document.querySelector(`${counterSelector} .js-current-slide`);
    const totalEl = document.querySelector(`${counterSelector} .js-total-slides`);

    const update = () => {
      const activeSlide = document.querySelector('.js-product-images-carousel .splide__slide.is-active:not(.splide__slide--clone)');

      if (activeSlide && activeSlide.hasAttribute('aria-label')) {
        const aria = activeSlide.getAttribute('aria-label');
        const match = aria.match(/^(\d+)\s+of\s+(\d+)$/);

        if (match) {
          currentEl.textContent = match[1];
          totalEl.textContent = match[2];
        }
      }

      requestAnimationFrame(update);
    };

    update();
  }

  productSizeGuide() {
    document.querySelectorAll('.js-open-size-guide').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const sizeGuide = document.querySelector(`.js-size-guide`);
        if (sizeGuide) {
          sizeGuide.classList.add('display');
          sizeGuide.querySelectorAll('.js-product-tab').forEach(tab => {
            tab.style.height = `auto`;
            const height = tab.scrollHeight;
            tab.setAttribute('data-height', height);
            tab.style.height = `${height}px`;
          });
          setTimeout(() => {
            sizeGuide.classList.add('active');
          }, 50);
          if (window.lenis) {
            window.lenis.stop();
          } else {
            document.body.style.overflow = 'hidden';
          }
        }
      });
    });

    document.querySelectorAll('.js-close-size-guide').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const sizeGuide = document.querySelector(`.js-size-guide`);
        if (sizeGuide) {
          sizeGuide.classList.add('closing');
          setTimeout(() => {
            sizeGuide.classList.remove('display', 'active', 'closing');
            if (window.lenis) {
              window.lenis.start();
            } else {
              document.body.style.overflow = 'visible';
            }
          }, 300);
        }
      });
    });
  }
}

if(document.querySelector("product-page")) {
  customElements.define("product-page", Product);
}